import React from "react";

interface IconProps {
  height?: string;
}

const Comment: React.FC<IconProps> = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96.25" height={props.height || "16px"}>
    <title>Feedback</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="feedback_icon">
          <path d="M91.789,15.012v47.334c0,5.514-4.486,10-10,10H50.122L32.376,90.039l0.003,0.003l-0.004-0.001l-0.056,0.056l-0.098-0.098&#10;&#9;l-8.765-2.369l3.219-3.193l-0.006-0.006l20.146-20.084h34.974c1.084,0,2-0.916,2-2V15.012c0-1.084-0.916-2-2-2H13.808&#10;&#9;c-1.094,0-2.019,0.925-2.019,2.019v47.315c0,1.084,0.916,2,2,2h6.956c4.404,0,8.006,3.583,8.03,7.987l0.029,1.874l0.004,0&#10;&#9;l-0.004,0.004l0.001,0.079l-0.079,0.001l-7.803,8.033l-0.109-7.914l-0.008,0l-0.03-1.996l-6.986-0.069c-5.514,0-10-4.486-10-10&#10;&#9;V15.031c0-5.524,4.495-10.019,10.019-10.019h67.981C87.303,5.012,91.789,9.498,91.789,15.012z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Comment;
